import * as React from 'react'
import I18n from '../../../../core/i18n'
import { agentService } from '../../../../core/services'
import { InputText, CheckBox } from '../../../atoms'
import AgentLayoutNew from '../_layouts/new'
import * as interfaces from '../../../../static/interfaces'

declare var window: interfaces.IWindow

const FIELDS = {
  name: 'name',
  description: 'description',
  is_active: 'is_active',
}

const AgentRolesNew: React.FC<{}> = () => {
  const handleSubmit = React.useCallback(async (initialValues, values) => {
    try {
      const { flush } = await agentService.createAgentRole(values)
      window.flashMessages.addMessage({ text: flush.message, type: flush.type })
      location.href = '/agent/agent_roles'
    } catch (e) {
      // 403等はhttpClientインターセプターでモーダル表示済み
    }
  }, [])

  return (
    <AgentLayoutNew
      model="agent_roles"
      title={`${I18n.t('generic.agent_roles')} - ${I18n.t('generic.create_new')}`}
      fields={FIELDS}
      indexLink="/agent/agent_roles"
      formItems={
        <>
          <InputText required={true} name="name" defaultValue="" label={I18n.t('generic.name')} />
          <InputText name="description" defaultValue="" label={I18n.t('generic.description')} />
          <CheckBox name="is_active" defaultChecked={true} label={I18n.t('generic.active')} />
        </>
      }
      handleSubmit={handleSubmit}
    />
  )
}

export default AgentRolesNew
